export const CREATE_CHALLENGE_PREFIX = 'create_challenge/';

export const CREATE_CHALLENGE_REQUESTED = `${CREATE_CHALLENGE_PREFIX}CHALLENGE_REQUESTED`;
export const CREATE_CHALLENGE_SUCCEEDED = `${CREATE_CHALLENGE_PREFIX}CHALLENGE_SUCCEEDED`;
export const CREATE_CHALLENGE_FAILED = `${CREATE_CHALLENGE_PREFIX}CHALLENGE_FAILED`;

export const FEATURED_CHALLENGE_REQUESTED = `${CREATE_CHALLENGE_PREFIX}FEATURED_CHALLENGE_REQUESTED`;
export const FEATURED_CHALLENGE_SUCCEEDED = `${CREATE_CHALLENGE_PREFIX}FEATURED_CHALLENGE_SUCCEEDED`;
export const FEATURED_CHALLENGE_FAILED = `${CREATE_CHALLENGE_PREFIX}FEATURED_CHALLENGE_FAILED`;

export const CLEAR_CREATED_CHALLENGE = `${CREATE_CHALLENGE_PREFIX}CLEAR_CREATED_CHALLENGE`;
